import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import '../css/App.css';

export default class Logo extends Component {
    render() {
        return (
            <Image src="https://mutual.club/assets/svg/logo_mutual.svg" className="img-fluid logo" responsive />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Logo.js